<template>
    <div
        class="container-fluid w-100"
        style="overflow: hidden"
    >
        <navbar
            :title="$t('menu.general_guides')"
            class="mb-2"
        />
        <div>
            <general-guides-search
                @search="searchSharedDocuments"
            />
            <div
                v-if="isObserver && !editMode"
                class="col-sm-12 mt-2"
            >
                <div
                    class="data-list-item add"
                    @click.stop="addNewGuide()"
                >
                    <div class="item-img-cont add-title">
                        <i class="fa fa-plus" />
                    </div>
                    <div class="item-text-cont">
                        <span class="item-title-add">{{ $t('common.add_new') }}</span>
                        <font-awesome-icon
                            icon="file-contract"
                            class="card-body-icon"
                        />
                    </div>
                </div>
            </div>
            <general-guides-list
                :class="{hidden:editMode}"
                :items="results"
                :loading="loading"
                :fetch-finished="fetchFinished"
                @edit="editDocumentDetails"
            />
        </div>
        <base-modal
            v-if="editMode"
            hide-header
            hide-footer
            size="lg"
            @close="showList"
        >
            <general-guides-editor
                ref="guidesEditor"
                :document="document"
                :editable="editable"
                @close="showList"
            />
        </base-modal>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import GeneralGuidesList from './GeneralGuidesList'
import GeneralGuidesEditor from './GeneralGuidesEditor'
import GeneralGuidesSearch from './GeneralGuidesSearch'
import BaseModal from "@/components/BaseModal";
import Navbar from "@/components/utils/Navbar";

export default {
    name: "GeneralGuides",
    components: {
        Navbar,
        BaseModal,
        GeneralGuidesList,
        GeneralGuidesEditor,
        GeneralGuidesSearch
    },
    mixins: [restApi],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            isMobile: false,
            loading: false,
            isObserver: true,
            editMode: false,
            editable: true,
            generalGuide: null,
            document: null,
            fetchFinished: false,
            lastSearchedParams: null,
            results: []
        }
    },
    methods:{
        addNewGuide: function () {
            this.document = {
                id: -1,
                name: '',
                description: '',
                added_time: null,
                added_by: null,
                attachment: null
            }
            this.editMode = true
        },

        showList: function () {
            this.searchSharedDocuments(this.lastSearchedParams)
            this.editMode = false
            this.document = null
        },

        editDocumentDetails: function (result) {
            this.editable = this.user ? result.company.id === this.user.company.id : false
            this.editMode = true
            this.setDocument(result)
        },

        setDocument: function (document) {
            this.document = document
        },

        searchSharedDocuments: function (params) {
            if (!params) {
                params = {searchMode: 1}
            }
            this.loading = true
            this.searchParams = params
            this.lastSearchedParams = params
            if (params.searchMode === 1) {
                this.restFetchParams(this.sharedDocumentUrl + '/sharedTo', this.searchParams, this.handleDocumentSearch, this.handleSearchFail)
            }
            else {
                this.restFetchParams(this.sharedDocumentUrl + '/sharedBy', this.searchParams, this.handleDocumentSearch, this.handleSearchFail)
            }
        },

        handleDocumentSearch: function (response) {
            if (response.status === 200) {
                this.fetchFinished = true
            }
            else {
                this.fetchFinished = false
            }
            this.results = response ? response.data : []
            this.loading = false
        },

        handleSearchFail() {
            this.loading = false
        }
    }
}
</script>

